/** InsCoder WANG.J 2026-07-21 B + Percentage mobile carousel progress. **/
document.querySelectorAll('[data-percentage-section]').forEach((section) => {
  const track = section.querySelector('[data-percentage-track]');
  const progress = section.querySelector('[data-percentage-progress]');

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
    const travel = max > 0 ? track.scrollLeft / max : 0;
    progress.style.transform = `translateX(${travel * (1 - visibleRatio) * 100}%) scaleX(${visibleRatio})`;
  };

  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
/** InsCoder WANG.J 2026-07-21 E + Percentage mobile carousel progress. **/
